import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { ILocationState } from '../../../../../models';
import { useGetOpportunity } from '../../../../../queries';
import { FullscreenModalNavLink } from '../../../fullscreen/FullscreenModalNavLink';
import { dataBoardStyles } from '../../DataBoardTable';

export const OpportunityNameLink = ({ opportunity }: { opportunity: Api.IOpportunity }) => {
	const listBoardId = opportunity.boardStage?.board?.id;
	const opportunityQuery = useGetOpportunity({ opportunityId: opportunity.id, enabled: !listBoardId });
	const boardId = listBoardId ?? opportunityQuery.data?.boardStage?.board?.id;
	const name = opportunity.name || 'Untitled opportunity';

	if (!boardId) {
		return <span>{name}</span>;
	}

	const state: ILocationState<Api.IOpportunity, unknown> = { model: opportunity };
	return (
		<FullscreenModalNavLink
			className={css(dataBoardStyles.link)}
			to={{ pathname: `/dataBoards/opportunities/${boardId}/${opportunity.id}`, state }}
		>
			{name}
		</FullscreenModalNavLink>
	);
};
